/*
 * book delivery date date picker, could do with refactoring to its own file
 */

import React, { Component } from 'react';

// third party
import Slider from 'react-slick';
import moment from 'moment';
import { decimalOrBust } from '../utilities/currency';
import { getOrdinal } from '../utilities/formatters';
import { config } from '../config';

const APP_INFO = config.APP_INFO;

function EcoLeaf() {
  return <div title="Eco day"><i className="sa sa-leaf eco-leaf" /></div>;
}

function SofaRescue() {
  return <div title="SofaRescue"><i className="sa sa-sync sofaRescue" /></div>;
}

function Day({ date, selected = false, onSelect, deliveryDateCutOff = 0, showEcoDates = true, extraClass = '' }) {
  // is a monday or a wednesday (hard coded as per current business rules)
  function isEcoDay(date) {
	  if(!showEcoDates)
		  return false;
    return [1, 3].includes(date.day());
  }

  function renderSpecialCase(date) {
    const saturdayCharge = parseFloat(date.surCharge);

    const extraCharges = date.ExtraCharges && date.ExtraCharges != null ?
      date.ExtraCharges.reduce((total, charge) =>
        total + (charge.RetailPrice * charge.Quantity)
        , 0) : 0;

    return (
      <React.Fragment>
        {saturdayCharge > 0 && (
          <div title="premium delivery charge">
            + £{decimalOrBust(saturdayCharge)}
          </div>)}

        {isEcoDay(date.delDate) && <EcoLeaf />}
		
        {extraClass != '' && !date.disabled && <SofaRescue />}

        {extraCharges > 0 && (
          <div className="storageCharges" title="storage charges">
            <span className="faded__line"></span>
            + £{decimalOrBust(extraCharges)}
          </div>)}
      </React.Fragment>
    );
  }

  const selectedClass = selected ? 'selected' : '';
  const cutOffDate = moment().add(deliveryDateCutOff, 'days');
  const isPassedCutOff = date.delDate.isBefore(cutOffDate);
  return (
    <div
      disabled={date.disabled || isPassedCutOff}
      className={`date-picker__day clickable-link ${selectedClass} ${extraClass}`}
      onClick={() => !date.disabled && onSelect(date)}
    >

      <div className="abreviation">
        {date.delDate.format('ddd')}
      </div>
      <div className="number">
        {date.delDate.format('D')}
      </div>
      <div className="special-case">
        {renderSpecialCase(date)}
      </div>

    </div>
  );
}

class DatePicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: null
    };
    this.DATES_PER_PAGE = 10; // config
    this.onSelectDay = this.onSelectDay.bind(this);
    this.renderDay = this.renderDay.bind(this);
  }

  onSelectDay(selectedDate) {
    const { onSelect } = this.props;
    // workaround for slick slider passing onClick through on slide end
    if(this.state.sliding) return;
    this.setState({
      selected: selectedDate
    });
    onSelect(selectedDate);
  }

  populateMissingDates(dates) {
    // not a fan of this but it works for now.
    const { DATES_PER_PAGE } = this;
    const sortedDates = dates.sort((a, b) => {
      if (b.delDate.isBefore(a.delDate)) return 1;
      if (a.delDate.isBefore(b.delDate)) return -1;
      return 0;
    });

    const latest = sortedDates[sortedDates.length - 1];
    const newDates = [sortedDates[0]];
    let currentDay = newDates[0].delDate;
    let currentIndex = 1;
    while (newDates[newDates.length - 1].delSchedIdx !== latest.delSchedIdx) {
      if (newDates.length > 50) break;
      currentDay = currentDay.clone().add(1, 'day');
      if (sortedDates[currentIndex].delDate.isSame(currentDay, 'day')) {
        newDates.push(sortedDates[currentIndex]);
        currentIndex += 1;
      } else {
        newDates.push({ delDate: currentDay, disabled: true });
      }
    }
    // fill in remaining dates so the page is filled
    while (newDates.length % DATES_PER_PAGE !== 0) {
      currentDay = currentDay.clone().add(1, 'day');
      newDates.push({ delDate: currentDay, disabled: true });
    }
    return newDates;
  }

  chunkArray(arr, chunkSize) {
    const newArr = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      newArr.push(arr.slice(i, i + chunkSize));
    }
    return newArr;
  }

  selectPageDate(dates) {
    const startDate = dates[0].delDate;
    const endDate = dates[dates.length - 1].delDate;
    if (startDate.isSame(endDate, 'month')) return startDate.format('MMMM');
    return `${startDate.format('MMM')}/${endDate.format('MMM')}`;
  }

  getStorageChargeInfo(dates) {
    let storageChargePerDay = 0;

    let firstStorageCharge = dates.find((date) => {
      if (!date.ExtraCharges || date.ExtraCharges === null) return false;
      return date.ExtraCharges && date.ExtraCharges !== null &&
        date.ExtraCharges.find(charge => charge.Item === 'STORAGE FEE');
    });

    if (firstStorageCharge) {
      firstStorageCharge = firstStorageCharge.ExtraCharges.find(charge => charge.Item === 'STORAGE FEE');
    }

    if (firstStorageCharge) {
      storageChargePerDay = firstStorageCharge.RetailPrice / firstStorageCharge.Quantity;
    }
    const freeDays = dates.reduce((freeDays, date) =>
      (!date.ExtraCharges || date.ExtraCharges === null) ? freeDays + 1 : freeDays, 0);
    return { freeDays, storageChargePerDay };
  }

  getCardContent(hasDates, contactNumber, pages, surchargeInfo, isCovidWhiteListed, isApolloOrder) {
      if (APP_INFO.SHOW_ALT_DELIVEY_COVID_MESSAGE === true && !isCovidWhiteListed){
        return (
          <div>
            <div className="c-html-part u-padding u-text-center">
              <p><font size="5">We're sorry, your delivery has been postponed</font><br/><br/></p>
              <p>In order to comply with the social distancing measures required at this time, we will be suspending all deliveries until we are advised by the Government that it is safe to resume.<br/><br/></p>
              <p>As soon as we are able, we will contact you to organise a new date for your delivery<br/><br/></p>
              <a href="https://www.sofology.co.uk/covid-19-faqs?">If you have any queries, please check our full FAQs</a>
            </div>
          </div>
        )
      }
      else {
        
        return (
          <div>
            {!hasDates && !isApolloOrder && (
              <div className="c-html-part u-padding u-text-center">
                <p>Can’t see a date that works for you?</p>
                <p>Our deliveries team will be able to advise you if there are a wider selection of available delivery dates.</p>
                <p>Please call the deliveries booking team on {contactNumber}</p>
              </div>
            )}

            {!hasDates && isApolloOrder && (
              <div className="c-html-part u-padding u-text-center">
              <p><font size="5">Let’s chat</font><br/><br/></p>
              <p>
                We need to speak to you about your delivery and clarify some
                information before we can give you suitable delivery dates.
              </p>
              <p>
                We’ll try to call you about boooking your delivery or,
                alternatively, please call us on <strong>03444 818181</strong>.
              </p> 
              </div>
            )}

            <Slider
              {...{ infinite: false, arrows: false, dots: true, dotsClass: 'date-picker__dots' }}
              beforeChange={() => this.setState({ sliding: true })}
              afterChange={() => this.setState({ sliding: false })}
            >
              {pages.map((page, i) => (
                <div key={`datepicker-slide${i}`}>

                  <div className="date-picker__month u-text-center u-padding-top-small">
                    AVAILABLE DATES IN {page.month}
                  </div>

                  <div className="date-picker">
                    {page.days.map(this.renderDay)}
                  </div>

                </div>
              ))}
            </Slider> 
              

            {surchargeInfo.storageChargePerDay > 0 && (
              <div className="storageCharge__message">
                Storage Charges: +£{decimalOrBust(surchargeInfo.storageChargePerDay)} per day after {getOrdinal(surchargeInfo.freeDays)} day
              </div>)}
          </div>
        )
      }
  }

  renderDay(date, i) {
    const { selected } = this.state;

    return (<Day
      date={date}
      onSelect={this.onSelectDay}
      selected={selected && date.delSchedIdx === selected.delSchedIdx}
      key={`datepicker-day-slide${i}`}
      deliveryDateCutOff={this.props.deliveryDateCutOff}
	  showEcoDates={this.props.showEcoDates}
	  extraClass={this.props.extraClass}
    />);
  }

  render() {
    const { dates } = this.props;
    const { DATES_PER_PAGE } = this;
    const { contactNumber } = this.props
    const { isCovidWhiteListed } = this.props
    const { isApolloOrder } = this.props
    // move these to umbraco configs
    const MAXIMUM_DATE_THROTTLE = 3;
    const SHOW_STORAGE_DAYS = false;
    let sortedDates = dates.sort((a, b) => {
      if (b.delDate.isBefore(a.delDate)) return 1;
      if (a.delDate.isBefore(b.delDate)) return -1;
      return 0;
    });

    if (!SHOW_STORAGE_DAYS) {
      sortedDates = sortedDates.filter(day => !day || !day.ExtraCharges || day.ExtraCharges === null);
    }

    // This is now handled by sending down the corrent number of dates from the back end
    //sortedDates = sortedDates.slice(0, MAXIMUM_DATE_THROTTLE);    
    let pages = [];
    let surchargeInfo = {};
    let hasDates = false;
    if (dates && dates.length) {
      const days = this.populateMissingDates(sortedDates);
      const noneDisabledDates = dates.filter(x =>
        x.disabled !== true && !x.delDate.isBefore(moment().add((this.props.deliveryDateCutOff || 0), 'day')));

      if (noneDisabledDates.length) {
        hasDates = true;
        surchargeInfo = this.getStorageChargeInfo(sortedDates);
        pages = this.chunkArray(days, DATES_PER_PAGE).reduce((acc, curr) =>
          acc.concat([{
            month: this.selectPageDate(curr), // curr[0].delDate.format('MMMM'),
            days: curr
          }]), []);
      }
    }

    return (
      <div>

        {this.getCardContent(hasDates, contactNumber, pages, surchargeInfo, isCovidWhiteListed, isApolloOrder)}

      </div>

    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/parts/DatePicker.js